// Normalizes a payload-insight `answer` field into 'PASS' | 'FAIL' | 'N/A'.
// Backend currently returns numeric codes (1 = PASS, 2 = FAIL, 3 = N/A);
// the original spec used string codes — accept both.
const normalizeAnswer = (answer) => {
	if (answer === 1 || answer === '1' || answer === 'PASS') return 'PASS';
	if (answer === 2 || answer === '2' || answer === 'FAIL') return 'FAIL';
	if (answer === 3 || answer === '3' || answer === 'N/A') return 'N/A';
	return null;
};

export default normalizeAnswer;
